import React, { useState, useEffect } from 'react';
import Logo from './NexriseLogo.png';
import BrandImg from './authentication.png';

const Login = ({ handleLogin }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth <= 1024;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      await handleLogin(email.trim(), password);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={{
        ...styles.card,
        width: isMobile ? '90%' : isTablet ? '90%' : '1000px',
        height: isMobile ? 'auto' : '650px',
        flexDirection: isMobile ? 'column' : 'row',
        margin: '20px auto'
      }}>
        {!isMobile && (
          <div style={styles.leftCol}>
            <img src={BrandImg} alt="Brand" style={styles.brandImage} />
          </div>
        )}

        <div style={{
          ...styles.rightCol,
          padding: isMobile ? '52px 20px' : '40px',
          minHeight: isMobile ? '400px' : 'auto'
        }}>
          <div style={styles.formContainer}>
            <img src={Logo} alt="NexBook Logo" style={{
              ...styles.logo,
              width: isMobile ? '140px' : '180px',
              marginBottom: isMobile ? '20px' : '28px'
            }} />
            <h1 style={{
              ...styles.title,
              fontSize: isMobile ? '24px' : '28px'
            }}>Log in to NexBook</h1>
            <p style={styles.subtitle}>Enter your email and password to continue</p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                style={styles.input}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                style={styles.input}
                required
              />
              <button type="submit" disabled={isSubmitting} style={styles.primaryButton}>
                {isSubmitting ? 'Signing in...' : 'Sign in'}
              </button>
            </form>
          </div>

          <footer style={{
            ...styles.footer,
            position: isMobile ? 'static' : 'absolute',
            marginTop: isMobile ? '40px' : '0'
          }}>
            © {new Date().getFullYear()} Nexrise India Infra Pvt. Ltd.
          </footer>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f3f4f6',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    display: 'flex',
    width: '1000px',
    height: '650px',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    overflow: 'hidden',
  },
  leftCol: {
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  rightCol: {
    flex: 1.2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    position: 'relative',
    backgroundColor: '#1b1b1d',
  },
  formContainer: {
    width: '100%',
    maxWidth: '360px',
    textAlign: 'center',
  },
  logo: {
    width: '180px',
    height: 'auto',
    marginBottom: '32px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: 'white',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#9ca3af',
    marginBottom: '28px',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    fontSize: '15px',
    color: '#111827',
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    boxSizing: 'border-box',
    outline: 'none'
  },
  primaryButton: {
    width: '100%',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '600',
    color: 'white',
    backgroundColor: '#8DC63F',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  footer: {
    position: 'absolute',
    bottom: '24px',
    color: '#6b7280',
    fontSize: '13px',
  },
};

export default Login;
